@if (this.news$ | async; as newsItems) {
  <div class="news-widget">
    <header class="news-widget__header">
      <h3 class="news-widget__title">{{ title }}</h3>
      <a href="{{ newsPageUrl }}" class="news-widget__header-more-cta">{{ 'uigNews.widgetHeaderMore' | cxTranslate }}</a>
    </header>
    <div class="news-widget__content">
      @for (newsItem of newsItems; track newsItem) {
        <section class="news-widget__section">
          @if (newsItem.summary && newsItem.date) {
            <div class="news-widget__date">{{ newsItem.date | date:'dd.MM.yyyy' }}</div>
            @if (newsItem.summary) {
              <span>
                <p [innerHTML]="newsItem.summary | safeHtml"
                  class="news-widget__text">
                </p>
                @if (newsItem.linkUrl && newsItem.linkName) {
                  <span>...</span>
                }
              </span>
            }
            @if (newsItem.linkUrl && newsItem.linkName) {
              <a href="{{ newsItem.linkUrl }}" class="news-widget__more-cta">{{ newsItem.linkName }}</a>
            }
          }
        </section>
      }
    </div>
  </div>
}
